import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const PaymentPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;

  td {
    height: ${pxToRem(55)};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(32)};
  justify-content: center;
  align-items: start;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;


export const StatsWrapper = styled.div`
  display: flex;
  justify-content: start;
  gap: ${pxToRem(158)};
  width: 100%;
  padding: ${pxToRem(16)} ${pxToRem(38)};
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
    0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const StatBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(6)};
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(16)};
  font-weight: 600;

  span {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 600;
  }
`;
